
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 15 15"}, attrs),
              ...rest,
            },
            children.concat([_c('circle',{attrs:{"cx":"7.5","cy":"11.856","r":".844"}}),_c('path',{attrs:{"fill":"#070808","d":"M7.5 11.013a.845.845 0 100 1.69.845.845 0 000-1.69zM7.5 2.269a.846.846 0 00-.845.844l.152 6.158a.692.692 0 001.384 0l.152-6.158a.843.843 0 00-.843-.844z"}}),_c('path',{attrs:{"fill":"#070808","d":"M7.501 1.149A6.357 6.357 0 0113.852 7.5a6.358 6.358 0 01-6.351 6.352A6.36 6.36 0 011.149 7.5a6.359 6.359 0 016.352-6.351m0-1.046a7.398 7.398 0 000 14.794A7.396 7.396 0 0014.897 7.5 7.396 7.396 0 007.501.103z"}})])
          )
        }
      }
    